import { APP_CONFIG } from '../constants/global-variables.js';
export async function liveCasinoCheck() {


    const url = `${APP_CONFIG.URL.apiBasePath}livecasino`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}